import { useState, useEffect } from 'react';
import Hobbies from '../Hobbies/Hobbies';
import './About.css';

function About() {
  const [imgFade, setImgFade] = useState({
    fade: 'fade-out',
    position: 'left',
  });
  const [textFade, setTextFade] = useState({
    fade: 'fade-out',
    position: 'top',
  });
  const [hobbieFade, setHobbieFade] = useState({
    fade: 'fade-out',
    position: 'bottom',
  });

  useEffect(() => {
    const timeout = setInterval(() => {
      if (imgFade.fade === 'fade-out') {
        setImgFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
      if (textFade.fade === 'fade-out') {
        setTextFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
      if (hobbieFade.fade === 'fade-out') {
        setHobbieFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
    }, 200);
    return () => clearInterval(timeout);
  }, [imgFade, textFade, hobbieFade]);
  return (
    <div className="about-container">
      <div
        className={`about__img-container ${imgFade.fade} ${imgFade.position}`}
      >
        <img src="./images/fotoCV.png" alt="Foto de Mariano Pedrini" />
      </div>

      <div className="about__desc">
        <p className={`about__text ${textFade.fade} ${textFade.position}`}>
          <span>
            Hola! Soy <strong>Mariano Pedrini</strong>
          </span>
          <br />
          un desarrollador FullStack de Argentina, apasionado por el diseño y la
          tecnología, detallista, creativo, entusiasta y siempre con ganas de
          aprender.
        </p>
        <Hobbies style={`${hobbieFade.fade} ${hobbieFade.position}`} />
      </div>
    </div>
  );
}

export default About;
